module.exports = "https://cdn2-fs.clearscore.com/flux/images/b5e5540d0c79d4bc70eed0257b03b996.jpg";